const AtivoEnum = {
    SIM: 'S',
    NAO: 'N'
};

export default AtivoEnum;
